import { MAP_NAMES, isGoogleMap, isHereMap } from "common/constants";

import { Geocoder, GeocoderFactory } from "./types";
import GoogleGeocoder from "./GoogleGeocoder";
import { HereGeocoder } from "./HereGeocoder";

export const geocoderFactory: GeocoderFactory = (
  mapName = MAP_NAMES.here
): Geocoder => {
  if (isGoogleMap(mapName)) return new GoogleGeocoder();
  if (isHereMap(mapName)) return new HereGeocoder();

  throw Error("There is no such a map");
};
